import PropTypes from 'prop-types';

import { Link } from 'react-router';

import { connect } from 'react-redux';

import { Text, theme } from '@prose-ui';
import { legacyTheme, styled } from '@prose-ui/legacy';

import { Button } from 'Components/LegacyButton';
import { breakpoints } from 'Components/ThemeProvider';

import desktopBackground from 'assets/images/membership/prose-assortment-of-custom-haircare-and-skincare-products-desktop.jpg';
import mobileBackground from 'assets/images/membership/prose-assortment-of-custom-haircare-and-skincare-products-mobile.jpg';
import tabletBackground from 'assets/images/membership/prose-assortment-of-custom-haircare-and-skincare-products-tablet.jpg';

import useMedia from 'utils/useMedia';

import * as subscriptionSelectors from 'dux/subscriptions/selectors';

// #region 1st Level - Wrapper
const HeroWrapper = styled('section')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  flexDirection: 'column',
  width: '100%',
  padding: '72px 24px',
  minHeight: 1000,
  height: 'calc(100vh - 100px)',
  backgroundColor: theme.colors.neutral[500],
  backgroundImage: `url(${mobileBackground.src})`,
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  [legacyTheme.breakpoints.up('sm')]: {
    backgroundImage: `url(${tabletBackground.src})`,
  },
  [legacyTheme.breakpoints.up('lg')]: {
    backgroundImage: `url(${desktopBackground.src})`,
  },
});
// #endregion

const CenteredFlex = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
});

const SubscriberHero = ({ memberSinceYear }) => {
  const isMobile = useMedia(`(max-width: ${breakpoints.sm - 1}px)`);
  // const isTablet = useMedia(`(max-width: ${breakpoints.lg - 1}px)`);

  return (
    <HeroWrapper>
      <CenteredFlex>
        <Text textAlign="center" variant={isMobile ? 'h3' : 'h2'}>
          Welcome back to{' '}
          <Text
            __fontSize={isMobile ? '28px' : '36px'}
            as="b"
            color="accent.300"
            variant="label1medium"
          >
            your subscription
          </Text>
        </Text>
        {memberSinceYear && <Text variant="label1medium">Member since {memberSinceYear}</Text>}
      </CenteredFlex>
      <CenteredFlex>
        <Button
          Component={Link}
          data-click="subscribe-summary"
          data-from="membership-lp-subscribers"
          to="/account/subscription/home"
          variant="lime"
        >
          Manage your subscription
        </Button>
      </CenteredFlex>
    </HeroWrapper>
  );
};

SubscriberHero.propTypes = {
  memberSinceYear: PropTypes.string,
};

SubscriberHero.defaultProps = {
  memberSinceYear: null,
};

export default connect(state => ({
  memberSinceYear: subscriptionSelectors.getMemberSince(state),
}))(SubscriberHero);
